import { render } from "./MerchantSupplier.vue?vue&type=template&id=8b0e7a7e&scoped=true"
import script from "./MerchantSupplier.vue?vue&type=script&lang=js"
export * from "./MerchantSupplier.vue?vue&type=script&lang=js"

import "./MerchantSupplier.vue?vue&type=style&index=0&id=8b0e7a7e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b0e7a7e"]])

export default __exports__